import { StateStream } from '@cgs/wge';
import {
  BuyFeatureRequestParams,
  GambleRequestParams,
  SpinInfoResponse,
  SpinResponse,
} from '@cgs/data-access';
import { MachineStateDto } from '@cgs/provider-cgs';
import { TrifectaMainDataAccessService } from './trifecta-main-data-access.service';
import { TrifectaRequestAbortedError } from './errors/trifecta-request-aborted.error';

export class TrifectaDemoDataAccessService extends TrifectaMainDataAccessService {
  private readonly spinsStream: StateStream<MachineStateDto[]> = new StateStream<MachineStateDto[]>(
    []
  );

  public override async spin(prevSpinResponse: SpinResponse | null): Promise<SpinInfoResponse> {
    if (!prevSpinResponse?.isFreeSpinsActive) {
      await this.raceWithAbort(this.spinsStream.toPromise());
    }

    return this.processSpinResponse();
  }

  public override async buyFeature(_params: BuyFeatureRequestParams): Promise<SpinInfoResponse> {
    await this.raceWithAbort(this.spinsStream.toPromise());
    return this.processSpinResponse();
  }

  public override async pickBonus(_params: unknown): Promise<SpinInfoResponse> {
    return this.processSpinResponse();
  }

  public override async gamble<Data = any>(
    _params: GambleRequestParams<Data>
  ): Promise<SpinInfoResponse> {
    await this.spinsStream.toPromise();
    return this.processSpinResponse();
  }

  private raceWithAbort<T>(promise: Promise<T>): Promise<T> {
    const abortPromise = this.abortStream.toPromise().then(() => {
      throw new TrifectaRequestAbortedError();
    });
    return Promise.race([promise, abortPromise]);
  }

  protected async processSpinResponse(): Promise<SpinInfoResponse> {
    const spins = this.spinsStream.state;
    const spin = spins.shift();

    if (!spin) {
      throw new Error('No spin data available');
    }

    this.spinsStream.emit(spins);

    return this.responseBuilder.buildSpinResultResponse({
      spin,
      balance: 0,
      sequence: 1,
    }).response;
  }

  public nextSpins(spins: MachineStateDto[]): void {
    this.spinsStream.emit([...spins]);
  }
}
